import { render, staticRenderFns } from "./Circles.vue?vue&type=template&id=2a4b7e94"
import script from "./Circles.vue?vue&type=script&lang=js"
export * from "./Circles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports